/**
 * Public SafeMeet site URL for share/join links (Next.js), not the API host.
 */
export const PUBLIC_SITE_URL = (
  process.env.REACT_APP_PUBLIC_SITE_URL
  || process.env.REACT_APP_MEETING_JOIN_BASE_URL
  || 'https://safemeet.ir'
).replace(/\/$/, '');

/**
 * Normalize a share URL to the frontend domain when path is /j/...
 */
export function normalizeShareUrl(url) {
  if (!url || typeof url !== 'string') return null;

  const trimmed = url.trim();
  if (!trimmed) return null;

  if (trimmed.startsWith('/j/')) {
    return `${PUBLIC_SITE_URL}${trimmed}`;
  }

  try {
    const parsed = new URL(trimmed);
    if (parsed.pathname.startsWith('/j/')) {
      return `${PUBLIC_SITE_URL}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return trimmed;
  }

  return trimmed;
}

/**
 * Build the public meeting share link from API payload fields.
 */
export function resolveMeetingShareUrl(meeting) {
  if (!meeting) return null;

  if (meeting.share_url) {
    return normalizeShareUrl(meeting.share_url);
  }

  if (meeting.join_slug) {
    return `${PUBLIC_SITE_URL}/j/${meeting.join_slug}`;
  }

  return normalizeShareUrl(meeting.join_url);
}
